<section class="flex items-center h-full p-16 dark:bg-gray-50 dark:text-gray-800" *ngIf="!setting">
	<div class="container flex flex-col items-center justify-center px-5 mx-auto my-8">
		<div class="max-w-md text-center">
			<h2 class="mb-8 font-extrabold text-9xl dark:text-gray-400">
				<span class="sr-only">Error</span>500
			</h2>
			<p class="text-2xl font-semibold md:text-3xl">Ocurrio un error al cargar el sitio</p>
			<p class="mt-4 mb-8 dark:text-gray-600">No fue posible obtener información de configuración del sistema, por favor contacta a un administrador.</p>
		</div>
	</div>
</section>

<div class="w-full h-full flex items-center justify-center flex-col lg:flex-row p-20" *ngIf="setting">
    <div class="flex justify-center flex-col order-2 lg:order-1 text-center lg:text-left">
        <h1 class="text-4xl font-semibold mb-8">AVISO DE CONFIDENCIALIDAD</h1>
        <p class="text-lg text-justify mb-12">
            {{ setting.noticeConfidentiality }}
        </p>
        <button class="button bg-laureate-500 w-fit px-20 text-white self-center lg:self-auto" (click)="acceptNoticeConfidentiality()">
            ACEPTAR
        </button>
    </div>
    <div class="flex items-center justify-center order-1 lg:order-2 lg:p-20 mb-10">
        <img class="w-9/12" src="/assets/imgs/notice-confidentiality.png" alt="Aviso de confidencialidad">
    </div>
</div>